// import axios from 'axios';
// import store from './store/index';
// import router from './router/index';
// import state from './store/state';

// export default () => {
//   axios.interceptors.response.use(
//     (response) => {
//       return response;
//     },
//     (error) => {
//       const refreshUrl = `${process.env.VUE_APP_ROOT_URL}/api/indobeauty/identity/v1/${state.distType}/refreshToken`;
//       const isRefreshRequest = error?.config?.url === refreshUrl;

//       // Jika request refreshToken itu sendiri yang gagal
//       if (isRefreshRequest) {
//         console.warn("Refresh token request failed → Logging out");
//         store.commit('logout');
//         router.push('/login');
//         return Promise.reject(error);
//       }

//       // Jika ada response dan bukan error 403, tampilkan error
//       if (error?.response && error.response.status !== 403) {
//         const errorMsg = error.response.data?.message || 'Unexpected error';
//         store.state.errorMessage = errorMsg;

//         store.commit("setShowSnackbar", {
//           snackbarMsg: errorMsg,
//           snackbarColor: "red",
//         });

//         return Promise.reject(error);
//       }

//       // Jika tidak ada config atau tidak ada response, reject langsung
//       if (!error?.config || !error.response) {
//         return Promise.reject(error);
//       }

//       // Coba refresh token
//       return axios.post(refreshUrl, {
//         refreshToken: store.state.refreshTokenWeb,
//         username: store.state.usernameWeb,
//       }, {
//         headers: {
//           "client-source-type": "CST_WEB",
//           "user-type": 'NON_ADMF',
//         }
//       })
//       .then((res) => {
//         // Simpan token baru
//         const { token, refreshToken, tokenExpDate } = res.data;

//         store.state.tokenWeb = token;
//         store.state.refreshTokenWeb = refreshToken;
//         store.state.tokenExpDateWeb = tokenExpDate;

//         // Ulangi request lama dengan token baru
//         const config = error.config;
//         config.headers['Authorization'] = token;

//         return axios.request(config);
//       })
//       .catch((refreshError) => {
//         // Jika refresh token GAGAL karena URL invalid, server error, dll
//         console.error("Token refresh failed (URL might be invalid):", refreshError);
//         store.commit('logout');
//         router.push('/login');
//         return Promise.reject(refreshError);
//       });
//     }
//   );
// };
import axios from 'axios';
import store from './store';
import router from './router';

export default () => {
  axios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;

      // Skip kalau tidak ada config atau tidak ada response
      if (!originalRequest || !error.response) {
        return Promise.reject(error);
      }

      const distType = store.state.distType;
      const refreshUrl = `${process.env.VUE_APP_ROOT_URL}/api/indobeauty/identity/v1/${distType}/refreshToken`;

      const isRefreshRequest = originalRequest.url === refreshUrl;

      // Jika refresh token itu sendiri yang gagal
      if (isRefreshRequest) {
        console.warn("Refresh token request failed → Logging out");
        store.commit('logout');
        router.push('/login');
        return Promise.reject(error);
      }

      // Jika status 403 (token expired) dan belum dicoba refresh
      if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true; // ← Mark request sudah diretry

        try {
          const res = await axios.post(refreshUrl, {
            refreshToken: store.state.refreshTokenWeb,
            username: store.state.usernameWeb,
          }, {
            headers: {
              "client-source-type": "CST_WEB",
              "user-type": 'NON_ADMF',
            }
          });

          const { token, refreshToken, tokenExpDate } = res.data;

          store.commit('setTokenWeb', token);
          store.commit('setRefreshTokenWeb', refreshToken);
          store.commit('setTokenExpDateWeb', tokenExpDate);

          // Ulangi request lama dengan token baru
          originalRequest.headers['Authorization'] = token;
          return axios.request(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed:", refreshError);
          store.commit('logout');
          router.push('/login');
          return Promise.reject(refreshError);
        }
      }

      // Tampilkan error selain 403
      if (error.response.status !== 403) {
        const errorMsg = error.response.data?.message || 'Unexpected error';
        store.commit("setShowSnackbar", {
          snackbarMsg: errorMsg,
          snackbarColor: "red",
        });
      }

      return Promise.reject(error);
    }
  );
};
